module.exports = [
  {
    name: 'Alabama',
    alias: 'AL',
    stateId: 'ac234a44-4cbe-49aa-a2db-4fef4eaa2e4c'
  },
  {
    name: 'Alaska',
    alias: 'AK',
    stateId: '07fb27fb-7d4c-4c02-a8f7-8a34b835314c'
  },
  {
    name: 'Arizona',
    alias: 'AZ',
    stateId: 'a6966681-73ba-46c8-9806-17521646db45'
  },
  {
    name: 'Arkansas',
    alias: 'AR',
    stateId: '2397e3af-ee72-42b9-bd9c-cb2de7842e92'
  },
  {
    name: 'California',
    alias: 'CA',
    stateId: '17e90f9f-6c1a-463a-8d09-0e7198a386ad'
  },
  {
    name: 'Colorado',
    alias: 'CO',
    stateId: '5a27bd85-1fb5-4d45-a5f5-4b72688024ba'
  },
  {
    name: 'Connecticut',
    alias: 'CT',
    stateId: '5092453d-db74-465e-a57c-edb776715e8f'
  },
  {
    name: 'Delaware',
    alias: 'DE',
    stateId: '1459c022-d2ef-41fd-be19-45f20472e073'
  },
  {
    name: 'District Of Columbia',
    alias: 'DC',
    stateId: '6be8cf71-636e-4d68-9731-c2de45ddb6ba'
  },
  {
    name: 'Florida',
    alias: 'FL',
    stateId: '43043415-ba34-445f-a58b-fedf2b432ac2'
  },
  {
    name: 'Georgia',
    alias: 'GA',
    stateId: 'b94ac5f5-bb29-4e3f-b13c-50c1739ab0f9'
  },
  {
    name: 'Hawaii',
    alias: 'HI',
    stateId: '661ade01-b2dd-4786-aa2a-dfc02f38e435'
  },
  {
    name: 'Idaho',
    alias: 'ID',
    stateId: 'd81c80ea-0710-4844-8bc8-d130cacd9caa'
  },
  {
    name: 'Illinois',
    alias: 'IL',
    stateId: '34d30102-10d2-4208-aa43-706b0eafba93'
  },
  {
    name: 'Indiana',
    alias: 'IN',
    stateId: 'e078837c-8895-48db-8bc7-5ac474ac3578'
  },
  {
    name: 'Iowa',
    alias: 'IA',
    stateId: 'e8c559a1-e33f-424f-9ca6-3695c4a9b5d5'
  },
  {
    name: 'Kansas',
    alias: 'KS',
    stateId: '3baee9a3-8527-4b14-9a22-61a68fa05c9d'
  },
  {
    name: 'Kentucky',
    alias: 'KY',
    stateId: '7b2bb37d-0d23-4786-b229-d4acf5f46623'
  },
  {
    name: 'Louisiana',
    alias: 'LA',
    stateId: 'bfb6d05d-de8a-4ea2-a11c-34c0f351cf9a'
  },
  {
    name: 'Maine',
    alias: 'ME',
    stateId: '6f989b69-f953-49af-95b2-b110059844a8'
  },
  {
    name: 'Maryland',
    alias: 'MD',
    stateId: '3e534137-bace-407a-8922-8f5659e3e870'
  },
  {
    name: 'Massachusetts',
    alias: 'MA',
    stateId: '94cf414f-7ab5-49f1-844c-2ed73029ceaa'
  },
  {
    name: 'Michigan',
    alias: 'MI',
    stateId: '3b0d44ad-c4fe-417d-976c-5ab758fd42a9'
  },
  {
    name: 'Minnesota',
    alias: 'MN',
    stateId: '1d2a2812-8c7e-449d-bbb5-06d3bafc0c4a'
  },
  {
    name: 'Mississippi',
    alias: 'MS',
    stateId: '4d7bf538-ea29-4e62-88aa-109d68f0b95f'
  },
  {
    name: 'Missouri',
    alias: 'MO',
    stateId: '3352294e-bbc7-4b1d-858d-6734f4b70856'
  },
  {
    name: 'Montana',
    alias: 'MT',
    stateId: 'ebee80aa-6848-410a-972c-86e1f593ab9a'
  },
  {
    name: 'Nebraska',
    alias: 'NE',
    stateId: '1a66f0d1-4be7-4fb8-9b1d-371c7c36efe0'
  },
  {
    name: 'Nevada',
    alias: 'NV',
    stateId: 'b29863e6-8f08-4764-8148-cbcfc385895d'
  },
  {
    name: 'New Hampshire',
    alias: 'NH',
    stateId: '08833b58-aa8a-48a8-bfe8-3270b10c10d6'
  },
  {
    name: 'New Jersey',
    alias: 'NJ',
    stateId: 'a5c5aef5-cb6e-4efc-891e-323c87226ebe'
  },
  {
    name: 'New Mexico',
    alias: 'NM',
    stateId: '0babefee-271f-437e-ac6a-bba4e72b68aa'
  },
  {
    name: 'New York',
    alias: 'NY',
    stateId: '3963d0e4-0664-4837-9582-a187283b6731'
  },
  {
    name: 'North Carolina',
    alias: 'NC',
    stateId: '74cd80f7-9917-4151-b9c3-8ec8b5ff8158'
  },
  {
    name: 'North Dakota',
    alias: 'ND',
    stateId: '6288442b-c266-4602-a46b-011e35bf9835'
  },
  {
    name: 'Ohio',
    alias: 'OH',
    stateId: '15211f4a-8fb3-4a60-ae82-574a465f7f5a'
  },
  {
    name: 'Oklahoma',
    alias: 'OK',
    stateId: 'ed8cacc6-09fb-40d9-bf3c-c25814085990'
  },
  {
    name: 'Oregon',
    alias: 'OR',
    stateId: '7ec85d8c-5123-4fd9-a184-226257c8f55e'
  },
  {
    name: 'Pennsylvania',
    alias: 'PA',
    stateId: 'a3a8bb45-1d46-417d-b125-fc6ad052ca5e'
  },
  {
    name: 'Rhode Island',
    alias: 'RI',
    stateId: '1b8492f2-c09f-4c2b-acd0-cc7777e5bf83'
  },
  {
    name: 'South Carolina',
    alias: 'SC',
    stateId: 'c2577fb8-f490-4186-bf6e-512e7c271854'
  },
  {
    name: 'South Dakota',
    alias: 'SD',
    stateId: '77b4fdb7-c14b-4c2d-a722-cacfb35d7bdb'
  },
  {
    name: 'Tennessee',
    alias: 'TN',
    stateId: 'da7c6717-e245-4130-8bc3-5059d63cf60c'
  },
  {
    name: 'Texas',
    alias: 'TX',
    stateId: '7e1547ed-fb23-4d23-9cbe-e972fb436cd3'
  },
  {
    name: 'Utah',
    alias: 'UT',
    stateId: 'caadaf37-025a-4306-a29b-b3452ac8016c'
  },
  {
    name: 'Vermont',
    alias: 'VT',
    stateId: '2e9f60f7-6ae2-4d4f-b617-4f0e89642753'
  },
  {
    name: 'Virginia',
    alias: 'VA',
    stateId: '30713a5a-c60a-4a91-9700-43c4bfb4614d'
  },
  {
    name: 'Washington',
    alias: 'WA',
    stateId: '7a481717-22d5-4688-aaf9-e35d4d8e95a2'
  },
  {
    name: 'West Virginia',
    alias: 'WV',
    stateId: '3d4ff4d4-66ab-4070-85e8-758bdb65edec'
  },
  {
    name: 'Wisconsin',
    alias: 'WI',
    stateId: '692970a4-51f1-40cd-a3da-7da2a3127285'
  },
  {
    name: 'Wyoming',
    alias: 'WY',
    stateId: '424d2347-69b3-497e-b245-a6209e639864'
  }
]
